// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3T-bw","footer":"styles_footer__1O2GD"};